import React, { useState, useRef } from 'react';
import './Contact.css';
import emailIcon from '../assets/email.png';
import { FaHandshake } from 'react-icons/fa'; // ✅ React icon added
import emailjs from '@emailjs/browser';

const Contact = () => {
  const form = useRef();
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // EmailJS credentials
    const serviceId = 'service_oecjxjk';
    const templateId = 'template_rpjesrd';
    const publicKey = 'BnjGXLdkLssr3tQ4o';

    emailjs.sendForm(serviceId, templateId, form.current, publicKey)
      .then((result) => {
          console.log('Email successfully sent!', result.text);
          alert('Thank you for your enquiry! We will get back to you soon.');
          setFormData({ name: '', company: '', email: '', message: '' });
      }, (error) => {
          console.error('Failed to send email:', error.text);
          alert('Failed to send the message, please try again.');
      });
  };

  return (
    <div className="contact">
      <section className="contact-hero">
        <div className="container">
          <h1 className="page-title" data-aos="fade-down">Contact Us</h1>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <div className="contact-wrapper">

            <div className="contact-info">
              <h2 data-aos="fade-right">Get in Touch</h2>

              <div className="contact-details">

                {/* EMAIL */}
                <div className="contact-item email-item" data-aos="fade-right">
                  <div className="contact-icon email-icon-wrapper">
                    <img src={emailIcon} alt="Email Icon" className="email-icon-image" />
                  </div>
                  <div>
                    <h4>Email</h4>
                    <a href="mailto:info@glandbotanica.com" className="contact-link">
                      info@glandbotanica.com
                    </a>
                  </div>
                </div>

                {/* PHONE */}
                <div className="contact-item phone-numbers-item" data-aos="fade-right">
                  <div className="contact-icon">📞</div>
                  <div>
                    <h4>Phone Numbers</h4>
                    <p className="contact-text">+91 9346729197</p>
                  </div>
                </div>

                {/* ✅ BUSINESS COLLAB (UPDATED ICON) */}
                <div className="contact-item business-item" data-aos="fade-right">
                  <div className="contact-icon business-icon">
                    <FaHandshake />
                  </div>
                  <div>
                    <h4>For Business Collaboration</h4>

                    <a href="mailto:snsiva@glandbotanica.com" className="contact-link">
                      snsiva@glandbotanica.com
                    </a>

                    <p className="contact-text">
                      Call: +91 94927 33833
                    </p>
                  </div>
                </div>

                {/* MAP */}
                <div className="contact-item map-location-item" data-aos="fade-right">
                  <div className="contact-icon">📍</div>
                  <div>
                    <h4>Map Location</h4>
                    <a
                      href="https://maps.app.goo.gl/P5YSvehRym8c1eGS6"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-link map-link"
                    >
                      View on Google Maps
                    </a>
                  </div>
                </div>

              </div>
            </div>

            {/* FORM */}
            <div className="contact-form-wrapper" data-aos="fade-left">
              <form ref={form} className="contact-form" onSubmit={handleSubmit}>
                <h2>Enquiry Form</h2>

                <div className="form-group">
                  <label>Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Company</label>
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Message *</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>

                <button type="submit" className="submit-btn">
                  Send Enquiry
                </button>
              </form>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;